import Vue from 'vue'
import {
    Button,
    Input,
    Container,
    Header,
    Aside,
    Footer,
    Main,
    Menu,
    MenuItem,
    Radio,
    RadioGroup,
    RadioButton,
    Drawer,
    Dropdown,
    DropdownMenu,
    DropdownItem,
    steps,
    Step,
    Select,
    Option,
    DatePicker,
    Pagination,
    Tabs,
    TabPane,
    Card,
    Breadcrumb,
    BreadcrumbItem,
    Dialog,
    Tag,
    Carousel,
    CarouselItem,
    Table,
    TableColumn,
    Message,
    MessageBox,
    CheckboxGroup,
    Checkbox,
    CheckboxButton,
    Loading,
    Cascader,

} from 'element-ui'

Vue.use(Button)
Vue.use(Input)
Vue.use(Container)
Vue.use(Header)
Vue.use(Aside)
Vue.use(Footer)
Vue.use(Main)
Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Radio)
Vue.use(RadioGroup)
Vue.use(RadioButton)
Vue.use(Drawer)
Vue.use(Dropdown)
Vue.use(DropdownMenu)
Vue.use(DropdownItem)
Vue.use(steps)
Vue.use(Step)
Vue.use(Select)
Vue.use(Option)
Vue.use(DatePicker)
Vue.use(Pagination)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(Card)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
Vue.use(Dialog)
Vue.use(Tag)
Vue.use(Carousel)
Vue.use(CarouselItem)
Vue.use(Table)
Vue.use(TableColumn)
Vue.use(CheckboxGroup)
Vue.use(Checkbox)
Vue.use(CheckboxButton)
Vue.use(Loading)
Vue.use(Cascader)





Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
















